export const services = [
  {
    id: 'emergency-plumbing',
    slug: 'emergency-plumbing',
    title: '24/7 Emergency Plumbing',
    description: 'Round-the-clock emergency plumbing services for your peace of mind.',
    image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?auto=format&fit=crop&q=80',
    features: [
      'Available 24/7',
      'Fast response time',
      'Licensed professionals',
      'Emergency repairs'
    ]
  },
  {
    id: 'drain-cleaning',
    slug: 'drain-cleaning',
    title: 'Drain Cleaning',
    description: 'Professional drain cleaning services to keep your plumbing flowing smoothly.',
    image: 'https://images.unsplash.com/photo-1584677626646-7c8f83690304?auto=format&fit=crop&q=80',
    features: [
      'Hydro jetting',
      'Drain snake service',
      'Camera inspection',
      'Preventive maintenance'
    ]
  },
  {
    id: 'water-heater',
    slug: 'water-heater',
    title: 'Water Heater Services',
    description: 'Installation, repair, and maintenance for all types of water heaters.',
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&q=80',
    features: [
      'Tank & tankless systems',
      'Repairs & maintenance',
      'New installations',
      'Energy efficient options'
    ]
  },
  {
    id: 'sewer-line-repair',
    title: 'Sewer Line Repair',
    description: 'Expert sewer line repair and replacement services with advanced diagnostic tools.',
    image: 'https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?auto=format&fit=crop&q=80',
    features: [
      'Video inspection',
      'Trenchless repair',
      'Line replacement',
      'Root removal'
    ]
  },
  {
    id: 'leak-detection',
    title: 'Leak Detection',
    description: 'Advanced leak detection services to find and fix hidden leaks quickly.',
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&q=80',
    features: [
      'Non-invasive detection',
      'Thermal imaging',
      'Pressure testing',
      'Moisture detection'
    ]
  },
  {
    id: 'bathroom-remodeling',
    title: 'Bathroom Remodeling',
    description: 'Complete bathroom remodeling services from design to installation.',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80',
    features: [
      'Custom designs',
      'Fixture installation',
      'Plumbing updates',
      'Modern solutions'
    ]
  },
  {
    id: 'gas-line-services',
    title: 'Gas Line Services',
    description: 'Professional gas line installation, repair, and maintenance services.',
    image: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&q=80',
    features: [
      'Leak detection',
      'New installations',
      'Safety inspections',
      'Emergency repairs'
    ]
  },
  {
    id: 'commercial-plumbing',
    title: 'Commercial Plumbing',
    description: 'Comprehensive plumbing solutions for businesses and commercial properties.',
    image: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&q=80',
    features: [
      '24/7 service',
      'Preventive maintenance',
      'Code compliance',
      'Large-scale projects'
    ]
  }
];